// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rich-text ul {
    list-style-type: disc;
    padding-left: 2.5rem
}
`, "",{"version":3,"sources":["webpack://./src/page-components/blog/[blog-item]/SectionsList/section.scss"],"names":[],"mappings":"AACE;IAAA,qBAAM;IAAN;AAAM","sourcesContent":[".rich-text ul {\n  @apply list-disc pl-10;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
